import { useEffect, useRef } from 'react';

// returns the value from the previous render (or undefined on first render)
// handy for when you need to compare the current value to the previous value to see if it changed
const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
